interface LocationInfoDTO {
    accountNumber: string;
    accountName: string;
    locationId: string;
    code: string;
    locationName: string;
    pos: string;
    sms: string;
    inactive: string;
    tenant: string;
}
const LocationInfoDTO = {
    create: (initValues?: Partial<LocationInfoDTO>): LocationInfoDTO => {
        const defaults: LocationInfoDTO = {
            accountName: '',
            accountNumber: '',
            locationId: '',
            code: '',
            locationName: '',
            pos: '',
            sms: '',
            inactive: '',
            tenant: ''
        };
       
        return { ...defaults, ...initValues };
    }
};

export default LocationInfoDTO;